import React,{useState, useEffect} from 'react'
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";

import Paginador from "../../Components/Pagination/pagination.js"

import DropdownButton from 'react-bootstrap/DropdownButton'

import {
  styled,
  TextField,
  Link,
  Dialog,
  DialogContent,
} from '@mui/material/';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: 'black',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'black',
  },
  '& .MuiOutlinedInput-root': {
    'background-image': 'none !important',
    '& fieldset': {
      borderColor: 'black',
    },
    '&:hover fieldset': {
      borderColor: 'black',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'black',
    },
  },
});

export default function DetailExclusions(props) {
  const {
    onCloseModal,
    searchInputModal,
    affectedAccounts,
    modalOppen,
    onChangeSearchInputModal,
    filterItemsModal,
    rowsForModal,
    page,
    rowsPerPage,
    totalRowsModal,
    pagesModal,
    previousPageModal,
    selectPageModal,
    nextPageModal,
    idRowSkuForModal,
    labelDropdown,
    handleDownload,
  } = props;
  const[prueba1, setPrueba1] = useState(0);
  const[rowsModal, setRowsModal] = useState(0)
  
  // useEffect(() => {
  //   setRowsModal(r => ...rowsForModal)
  // }, [rowsForModal]);

  const modalTableColumns =[
    "ID",
    "Cliente",
    "Gerencia de ventas",
    "UEN",
    "Canal"
  ];
  console.log("🚀 ~ file: DetailExclusions.jsx ~ line 5 ~ DetailExclusions ~ prueba1", prueba1)
  
  const StyledTableCellModal = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: "#FFFF00",
      fontFamily: "Roboto",
      fontstyle: "normal",
      fontWeight: "normal",
      fontSize: 18,
      padding: "20px 30px",
    },
    body: {
      fontSize: 14,
      padding: "15px 30px",
      maxHeight: "50rem",
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow); 

  return (
    <Dialog
            onClose={onCloseModal}
            open={modalOppen}
            className="loader__dialogPaperModal"
            fullWidth
            maxWidth="lg"
          >
            <Grid container item xs={12} justifyContent="flex-end">
              {/* <Grid container item xs={6}> */}
                {/* <Grid item xs={6}> */}
                  <div className="loader__title__detalle">
                    {affectedAccounts !== 0 ? `${affectedAccounts}` : " - " } Clientes impactados
                  </div>
                {/* </Grid> */}
              {/* </Grid> */}
              {/* <Grid item xs={6}> */}
              <div
                className="barraBusqueda"
                // style={{
                //   marginTop: 1
                // }}
              >
                <CssTextField
                  label="Bucador"
                  // disabled={totalRowsModal.affectedAccounts === undefined || totalRowsModal.affectedAccounts === 0}
                  // label="Sku/Cliente.."
                  className="textField"
                  name="busqueda"
                  id="search"
                  sx={{
                    width: '10ch',
                  }}
                  value={searchInputModal}
                  onChange={onChangeSearchInputModal}
                  onKeyDown={filterItemsModal}
                />
              </div>
              {/* </Grid> */}
            </Grid>
            <DialogContent
              style={{height: "400rem", width: "70rem"}}
            >
              <div className="loader__table">
                <TableContainer
                  component={Paper}
                  classes={{ container: { maxHeight: 1000 } }}
                  sx={{ minWidth: 650 }}
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {modalTableColumns.map((element, key) => (
                          <StyledTableCellModal align="left" key={key}>
                            {element}
                          </StyledTableCellModal>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowsForModal.length > 0 ? (
                        rowsForModal
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                          <StyledTableRow>
                            <StyledTableCellModal align={row.client_id === null ? "center" : "left"}>
                              {row.client_id === null ? "-" : row.client_id}
                            </StyledTableCellModal>
                            <StyledTableCellModal align={row.client_name === null ? "center" : "left"}>
                              {row.client_name === null ? "-" : row.client_name}
                            </StyledTableCellModal>
                            <StyledTableCellModal align={row.gerencia === null ? "center" : "left"}>
                              {row.gerencia === null ? "-" : row.gerencia}
                            </StyledTableCellModal>
                            <StyledTableCellModal align={row.uen === null ? "center" : "left"}>
                              {row.uen === null ? "-" : row.uen}
                            </StyledTableCellModal>
                            <StyledTableCellModal align={row.channel === null ? "center" : "left"}>
                              {row.channel === null ? "-" : row.channel}
                            </StyledTableCellModal>
                          </StyledTableRow>
                        ))
                      )
                      :
                      totalRowsModal.accounts ? totalRowsModal.accounts.length > 0 ? (
                        totalRowsModal.accounts
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                          <StyledTableRow>
                              <StyledTableCellModal align={row.client_id === null ? "center" : "left"}>
                                {row.client_id === null ? "-" : row.client_id}
                              </StyledTableCellModal>
                              <StyledTableCellModal align={row.client_name === null ? "center" : "left"}>
                                {row.client_name === null ? "-" : row.client_name}
                              </StyledTableCellModal>
                              <StyledTableCellModal align={row.gerencia === null ? "center" : "left"}>
                                {row.gerencia === null ? "-" : row.gerencia}
                              </StyledTableCellModal>
                              <StyledTableCellModal align={row.uen === null ? "center" : "left"}>
                                {row.uen === null ? "-" : row.uen}
                              </StyledTableCellModal>
                              <StyledTableCellModal align={row.channel === null ? "center" : "left"}>
                                {row.channel === null ? "-" : row.channel}
                              </StyledTableCellModal>
                            </StyledTableRow>
                          ))
                      ) : (
                        <StyledTableRow>
                          <StyledTableCellModal colSpan={5} align="center">
                            No hay clientes impactados
                          </StyledTableCellModal>
                        </StyledTableRow>
                      ) : ""}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </DialogContent>
            <div className="loader__actions__modal">
              <div className="loader__pagerModal">
                <Paginador
                  pagesModal= {pagesModal}
                  pagesModalState={pagesModal}
                  previousPageModal={previousPageModal}
                  selectPageModal={selectPageModal}
                  nextPageModal={nextPageModal}
                />
                <DetailExclusions />
              </div>
                <DropdownButton
                  className="loader__dropdown yellowModall"
                  onClick={handleDownload("exclutionsForProduct", idRowSkuForModal, totalRowsModal.affectedAccounts)}
                  title={labelDropdown}
                  disabled={totalRowsModal.affectedAccounts === undefined || totalRowsModal.affectedAccounts === 0}
                >
                </DropdownButton>
            </div>
          </Dialog>
  )
}
